import Heading from './parts/Heading'
import { ColorEnum } from '@/constants/color'
import { ProductItem as ProductItemType } from '@/features/common/components/Overview/parts/ProductItem/types'
import CartContainerItem from '@/features/pos/components/Cart/parts/Overview/parts/CartContainerItem'
import { ContainerItem } from '@/features/pos/components/Cart/parts/Overview/parts/CartContainerItem/types'
import CartItem from '@/features/pos/components/Cart/parts/Overview/parts/CartItem'
import { useScreenLayout } from '@/hooks/screen'
import { FC } from 'react'
import { StyleSheet, View } from 'react-native'

interface CartOverviewProps {
    items: ProductItemType[]
    containerItems: ContainerItem[]
    onDelete: (id: string) => void
    onDeleteContainerItem: (id: string) => void
    onChangeQuantity: (id: string, changeQuantity: number) => void
    onChangeContainerItemQuantity: (id: string, changeQuantity: number) => void
    onEditAutomaticContainers: (id: string) => void
    itemIdsWithAutomaticContainers: readonly string[]
    expandedItemId: string | null
    onToggleItem: (id: string) => void
}

const CartOverview: FC<CartOverviewProps> = ({
    items,
    containerItems,
    onDelete,
    onDeleteContainerItem,
    onChangeQuantity,
    onChangeContainerItemQuantity,
    onEditAutomaticContainers,
    itemIdsWithAutomaticContainers,
    expandedItemId,
    onToggleItem,
}) => {
    const layout = useScreenLayout()

    return (
        <View style={styles.container}>
            <Heading layout={layout} />
            <View style={styles.itemListContainer}>
                {items.map((item) => (
                    <CartItem
                        key={item.id}
                        productItem={item}
                        onDelete={onDelete}
                        onChangeQuantity={onChangeQuantity}
                        onEditAutomaticContainers={onEditAutomaticContainers}
                        hasAutomaticContainers={itemIdsWithAutomaticContainers.includes(item.id)}
                        expanded={expandedItemId === item.id}
                        onToggle={() => onToggleItem(item.id)}
                        compact={layout === 'compact'}
                    />
                ))}
                {containerItems.map((item) => {
                    const itemKey = `container-${item.id}`

                    return (
                        <CartContainerItem
                            key={itemKey}
                            containerItem={item}
                            onDelete={onDeleteContainerItem}
                            onChangeQuantity={onChangeContainerItemQuantity}
                            expanded={expandedItemId === itemKey}
                            onToggle={() => onToggleItem(itemKey)}
                            compact={layout === 'compact'}
                        />
                    )
                })}
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 16,
        alignSelf: 'stretch',
        backgroundColor: ColorEnum.WHITE,
        gap: 8,
    },
    itemListContainer: {
        gap: 8,
    },
})

export default CartOverview
